import React from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { useTestSessionsData } from '@modmd/data'
import { TestSessionsDatalist } from 'sharedComponents/TestSessionsDatalist'
import Datalist from 'components/Datalist'
import { ROUTES } from 'internal-portal/constants/routes'
import { useStatuses } from 'utils/hooks/useStatuses'

interface Params {
  companyId: string
}

export const CompanySessions: React.VFC = () => {
  const params = useParams<Params>()
  const history = useHistory()
  const { getStatuses } = useStatuses()
  const [testSessionsPage, setTestSessionsPage] = React.useState(1)

  const testSessionsQuery = useTestSessionsData({
    filter: {
      companyId: params.companyId,
      statuses: getStatuses(),
    },
    page: testSessionsPage,
  })

  return (
    <TestSessionsDatalist
      tableHeader={<Datalist.Title>Test sessions</Datalist.Title>}
      columnLabels={{
        numOfPeople: null,
        company: null,
        invoiceCheck: null,
      }}
      testSessions={testSessionsQuery.data?.testSessions?.testSessions || []}
      pagination={testSessionsQuery.data?.testSessions?.pagination}
      isLoading={testSessionsQuery.loading}
      hasPaginationInFooter
      onPageChange={setTestSessionsPage}
      onRowClick={({ id }) => history.push(`/${ROUTES.SESSIONS}/${String(id)}`)}
    />
  )
}
